import { render } from "./ChangeStackDialog.vue?vue&type=template&id=4389cd1c"
import script from "./ChangeStackDialog.vue?vue&type=script&lang=js"
export * from "./ChangeStackDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__